import React from "react";
import Card from "components/card";
import { useDispatch, useSelector } from "react-redux";
import OvertimeForm from "./OvertimeForm";
import { MODULE_OVERTIME } from "variables/constants";
import { formatDateRange } from "utils";
import CrudOption from "components/dropdown/crudoption";
import {
    doOvertimeDelete
} from "../../../../redux/overtime/overtimeState";

const OvertimeCard = ({ 
    recordList
}) => {

    const dispatch = useDispatch();
    const doDelete = (id) => dispatch(doOvertimeDelete(id));

    const currentUserLevel = useSelector((state) => state.auth.user.user_level);
    return (
        <>
            {recordList?.map((item) => {
                const statusKey = item?.ots_status_name?.toLowerCase();
                return (
                    <Card
                        key={item.ots_id}
                        className="p-4 border border-slate-200 rounded-2xl hover:shadow-md transition-all mb-4"
                    >
                        <div className="grid grid-cols-[1fr_auto] gap-4 items-start md:grid-cols-12">
                            <div className="md:col-span-9">
                                <div className="md:grid md:grid-cols-9 md:gap-4">
                                    <div className="md:col-span-4">
                                        {currentUserLevel !== 5 && (
                                            <p className="text-base font-semibold text-slate-700 dark:text-white/70 min-h-[24px]">
                                                {item.ots_employee_name}
                                            </p>
                                        )}
                                        <p className="text-sm font-semibold dark:text-white tracking-normal">
                                            {formatDateRange(item.date_time_start, null, null, true, true)}
                                            {" "}
                                            to{" "}
                                            {formatDateRange(item.date_time_end, null, null, true, true)}
                                        </p>
                                        
                                    </div>
                                    <div className="mt-2 md:mt-0 md:col-span-5">
                                        <p className="text-xs uppercase tracking-wide text-slate-600">
                                            Reason
                                        </p>

                                        <p className="mt-1 text-sm text-slate-700 dark:text-slate-200">
                                            {item.ots_reason}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-start gap-2 md:col-span-3 md:justify-end">
                                <span className={`status-indicator ${statusKey}`}>
                                    {item.ots_status_name}
                                </span>

                                {item.ots_status_name === "Pending" && (
                                    <div className="-mt-0.5">
                                        <CrudOption
                                            buttonClassName="inline-flex items-center rounded-xl border border-slate-300 px-2 py-0.5 text-xs hover:bg-slate-50 dark:border-slate-600 dark:hover:bg-slate-800 dark:text-white/70"
                                            baseRoute="/console/overtimes"
                                            recordId={item.ots_id}
                                            moduleId={MODULE_OVERTIME}
                                            title="Edit Overtime"
                                            editMode="modal"
                                            allowView={false}
                                            allowEdit
                                            allowDelete={false}
                                            allowDetail={false}
                                            allowCancel
                                            deleteHandler={doDelete}
                                            editHandler={(recordId, closeModal) => (
                                                <div className="max-h-[80vh] overflow-y-auto">
                                                    <OvertimeForm
                                                        recordId={recordId}
                                                        mode="edit"
                                                        onCancel={closeModal}
                                                    />
                                                </div>
                                            )}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mt-4 border-t pt-3 flex justify-between text-xs text-slate-600 tracking-normal dark:text-white/70">
                            <span className="font-medium">
                                {item.ots_status_name === "Approved"
                                    ? "Approved:"
                                    : "Requested:"}{" "}
                                {item.ots_status_name === "Approved"
                                    ? item.approved_duration_string
                                    : item.duration_string}
                            </span>
                            <span className="">
                                Date Filed: {formatDateRange(item.created_at)}
                            </span>
                        </div>
                    </Card>
                );
            })}
        </>
    );
};

export default (OvertimeCard);
